import React from 'react';
import { Box, Chip, Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useThemeSettings } from '../../../../contexts/ThemeContext';
import { SUPPORT_TYPE_LABELS } from '../../utils/ticketConstants';

/**
 * Display active filter chips with remove functionality
 */
const FilterChips = ({
  filter,
  onFilterChange,
  onResetFilter
}) => {
  const { t } = useThemeSettings();

  const hasFilters = filter.status.length > 0 ||
    filter.urgency ||
    filter.support_type ||
    filter.next_step;

  if (!hasFilters) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2, alignItems: 'center' }}>
      {/* Status chips */}
      {filter.status.length > 0 && filter.status.map((status) => (
        <Chip
          key={`status-${status}`}
          label={`${t ? t('Tickets.status') : 'Status'}: ${status}`}
          size="small"
          onDelete={() => onFilterChange('status', filter.status.filter(s => s !== status))}
          deleteIcon={<CloseIcon />}
        />
      ))}

      {/* Urgency chip */}
      {filter.urgency && (
        <Chip
          label={`${t ? t('Tickets.urgency') : 'Urgency'}: ${filter.urgency}`}
          size="small"
          onDelete={() => onFilterChange('urgency', '')}
          deleteIcon={<CloseIcon />}
        />
      )}

      {/* Support type chip */}
      {filter.support_type && (
        <Chip
          label={`${t ? t('Tickets.support_type') : 'Type'}: ${SUPPORT_TYPE_LABELS[filter.support_type] || filter.support_type}`}
          size="small"
          onDelete={() => onFilterChange('support_type', '')}
          deleteIcon={<CloseIcon />}
        />
      )}

      {/* Next step chip */}
      {filter.next_step && (
        <Chip
          label={`${t ? t('Tickets.next_step') : 'Next Step'}: ${filter.next_step}`}
          size="small"
          onDelete={() => onFilterChange('next_step', '')}
          deleteIcon={<CloseIcon />}
        />
      )}

      {/* Clear all button */}
      <Button
        size="small"
        onClick={onResetFilter}
        sx={{ ml: 1 }}
      >
        {t ? t('Tickets.clear_all') : 'Clear All'}
      </Button>
    </Box>
  );
};

export default FilterChips;
